import React from 'react';

function PlaceholderCodeIcon(props) {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2"
        y="5"
        width="61"
        height="54"
        rx="4.4"
        fill="#F0F2F5"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path d="M2 9.4C2 7 4 5 6.4 5h52.2C61 5 63 7 63 9.4v5.2H2V9.4Z" fill="#8E959E" />
      <path
        d="m24.2 30.5-5.9 5.9c-.3.3-.3.9 0 1.2l5.9 5.9m16.2-13 5.9 5.9c.3.3.3.9 0 1.2l-6 5.9m-12 4.8 8-22.6"
        stroke="#8E959E"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6.8" cy="9.8" r="1.7" fill="#B0B8BF" />
      <circle cx="11.6" cy="9.8" r="1.7" fill="#B0B8BF" />
      <circle cx="16.4" cy="9.8" r="1.7" fill="#B0B8BF" />
    </svg>
  );
}

export default PlaceholderCodeIcon;
